import axios from "axios";
import {
  authHeader,
  authHeaderWithMultipartData,
} from "../authservice/auth-header";

const API_URL = process.env.VUE_APP_ROOT_API

class HotelService {
  // DASHBOARD RELATED APIs

  //  Get Dashboard infomation data
  getDashboard(filter = "") {
    return axios
      .get(API_URL + "hotel/dashboard" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // HOTEL DETAILS RELATED APIs

  // hotel details
  getHotelDetails() {
    return axios
      .get(API_URL + "hotel/detail", { headers: authHeader() })
      .then((response) => {
        localStorage.setItem("hotel", JSON.stringify(response.data));
        return response.data;
      });
  }
  // update hotel details
  updateHotelDetails(data) {
    return axios
      .patch(API_URL + "hotel/detail", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // REGISTER HOTEL RELATED APIs

  // get brand list for create new hotel
  brandList() {
    return axios
      .get(API_URL + "hotel/brand", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // register new hotel
  registerHotel(data) {
    return axios
      .post(API_URL + "hotel/create", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get all hotels while adding new one
  getAllHotels(filter = "") {
    return axios
      .get(API_URL + "hotel/list" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // HOTEL INFO AND SERVICES RELATED APIs

  // Get hotel information and services
  getInfoAndServices(filter = "") {
    return axios
      .get(API_URL + "hotel/info-place" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add hotel information and services
  addInfoAndServices(data) {
    return axios
      .post(API_URL + "hotel/info-place", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update hotel information and services
  updateInfoAndServices(info_and_services_id, data) {
    return axios
      .patch(API_URL + "hotel/info-place/" + info_and_services_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete hotel information and services
  deleteInfoAndServices(info_and_services_id) {
    return axios
      .delete(API_URL + "hotel/info-place/" + info_and_services_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add images to hotel info and services
  addImageToInfoAndServices(hotel_info_place_id, data) {
    return axios
      .post(API_URL + "hotel/info-place-image/" + hotel_info_place_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update images to hotel info and services
  updateImageToInfoAndServices(
    hotel_info_place_id,
    hotel_info_place_image_id,
    data
  ) {
    return axios
      .patch(
        API_URL +
          `hotel/info-place-image/${hotel_info_place_id}/${hotel_info_place_image_id}`,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete images to hotel info and services
  deleteImageToInfoAndServices(hotel_info_place_id, hotel_info_place_image_id) {
    return axios
      .delete(
        API_URL +
          `hotel/info-place-image/${hotel_info_place_id}/${hotel_info_place_image_id}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // MAIN CATEGORY RELATED APIs

  // Get near by place  category
  getNearByPlaceCategory() {
    return axios
      .get(API_URL + "hotel/nearby-place/category", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add near by place  category
  addNearByPlaceCategory(data) {
    return axios
      .post(API_URL + "hotel/nearby-place/category", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update near by place  category
  updateNearByPlaceCategory(near_place_c_id, data) {
    return axios
      .patch(API_URL + "hotel/nearby-place/category/" + near_place_c_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete near by place  category
  deleteNearByPlaceCategory(near_place_c_id) {
    return axios
      .delete(API_URL + "hotel/nearby-place/category/" + near_place_c_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //NEAR BY PLACE RELATED APIs

  // Get near by place list
  getNearByPlaceList(query) {
    return axios
      .get(API_URL + "hotel/nearby-place/place" + query, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add near by place list
  addNearByPlace(data) {
    return axios
      .post(API_URL + "hotel/nearby-place/place", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update near by place
  updateNearByPlace(near_place_id, data) {
    return axios
      .patch(API_URL + "hotel/nearby-place/place/" + near_place_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete near by place list
  deleteNearByPlace(near_place_id) {
    return axios
      .delete(API_URL + "hotel/nearby-place/place/" + near_place_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //NEAR BY PLACE IMAGES RELATED APIs

  // Add  near by place list image
  addNearByPlaceImage(near_place_id, data) {
    return axios
      .post(
        API_URL + "hotel/nearby-place/" + near_place_id + "/place-image",
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Update near by place list image
  updateNearByPlaceImage(near_place_id, near_place_image_id, data) {
    return axios
      .patch(
        API_URL +
          "hotel/nearby-place/" +
          near_place_id +
          "/place-image/" +
          near_place_image_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete near by place list image
  deleteNearByPlaceImage(near_place_id, near_place_image_id) {
    return axios
      .delete(
        API_URL +
          "hotel/nearby-place/" +
          near_place_id +
          "/place-image/" +
          near_place_image_id,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  //LOCAL EVENT RELATED APIs

  // Get local event list
  getLocalEventList(filter) {
    return axios
      .get(API_URL + "hotel/local-event" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add local event list
  addLocalEvent(data) {
    return axios
      .post(API_URL + "hotel/local-event", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update local event
  updateLocalEvent(local_event_id, data) {
    return axios
      .patch(API_URL + "hotel/local-event/" + local_event_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete local event list
  deleteLocalEvent(local_event_id) {
    return axios
      .delete(API_URL + "hotel/local-event/" + local_event_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // TV CHANNEL RELATED APIs

  // Get tv channel category list
  getTvChannelCategory() {
    return axios
      .get(API_URL + "hotel/tv-channel/category", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add tv channel category
  addTvChannelCategory(data) {
    return axios
      .post(API_URL + "hotel/tv-channel/category", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update tv channel category
  updateTvChannelCategory(tv_channel_category_id, data) {
    return axios
      .patch(
        API_URL + "hotel/tv-channel/category/" + tv_channel_category_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete tv channel category
  deleteTvChannelCategory(tv_channel_category_id) {
    return axios
      .delete(API_URL + "hotel/tv-channel/category/" + tv_channel_category_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get TV channel list by category
  getTvChannelList(query) {
    return axios
      .get(API_URL + "hotel/tv-channel/info" + query, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add TV Channel
  addTVChannel(data) {
    return axios
      .post(API_URL + "hotel/tv-channel/info", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update TV Channel
  updateTVChannel(near_place_id, data) {
    return axios
      .patch(API_URL + "hotel/tv-channel/info/" + near_place_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete TV Channel
  deleteTVChannel(near_place_id) {
    return axios
      .delete(API_URL + "hotel/tv-channel/info/" + near_place_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //   ROLE AND ROLE PERMISSION RELATED APIs

  //role list
  getRoleList() {
    return axios
      .get(API_URL + "hotel/role", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create role
  createRole(data) {
    return axios
      .post(API_URL + "hotel/role", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Edit role
  editRole(id, data) {
    return axios
      .patch(API_URL + "hotel/role/" + id, data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Delete role
  deleteRole(id) {
    return axios
      .delete(API_URL + "hotel/role/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  //Role permission
  getRolePermissionList(role_id) {
    return axios
      .get(API_URL + "hotel/role-permission/" + role_id, {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }
  // update role permission
  updateRolePermissionList(role_permission_id, data) {
    return axios
      .patch(
        API_URL + "hotel/role-permission-edit/" + role_permission_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => response.data);
  }
  // Update all permission
  UpdateAllRolePermissions(role_id, data) {
    return axios
      .post(
        API_URL + "hotel/role-permission/" + role_id + "/bulk-update",
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => response.data);
  }

  // MAINTENCE REQURED RELATED APIs

  //Get all maintence request
  getAllMaintenceRequest() {
    return axios
      .get(API_URL + "hotel/maintenance-issue", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create new maintence request
  createMaintenceRequest(data) {
    return axios
      .post(API_URL + "hotel/maintenance-issue", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  update maintence request by id
  updateMaintenceRequest(id, data) {
    return axios
      .patch(API_URL + "hotel/maintenance-issue/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete maintence request by id
  deleteMaintenceRequest(id) {
    return axios
      .delete(API_URL + "hotel/maintenance-issue/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Get details of maintence request item by id
  getMaintenceRequestDetails(id) {
    return axios
      .get(API_URL + "hotel/maintenance-issue/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //  Get Maintenance List Data
  getAllMaintenanceReq() {
    return axios
      .get(API_URL + "hotel/maintenance-detail", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //  Full Data of Maintenance  List
  getFullReqData(id) {
    return axios
      .get(API_URL + "hotel/maintenance-detail/" + id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  update maintence request by id
  updateReqData(id, data) {
    return axios
      .patch(API_URL + "hotel/maintenance-detail/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  Create New Maintence Request
  createNewMaintenanceReq(data) {
    return axios
      .post(API_URL + "hotel/maintenance-detail", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //  Create New Maintence Log
  createMaintenceLog(data) {
    return axios
      .post(API_URL + "hotel/maintenance-log", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // USER REVIEWS RELATED APIs

  // get all review list by user
  getUserReviewListByFilter(filter_string) {
    return axios
      .get(API_URL + "hotel/user-review" + filter_string, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // GET BRAND BASE THEME APIs

  // Get brand based themes
  getBrandWiseThemes(brand_id) {
    return axios
      .get(API_URL + "hotel/brand/" + brand_id + "/theme", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Get all themes list
  getAllThemes() {
    return axios
      .get(API_URL + "hotel/brand/theme/all", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // BOOKING SOURCE LIST RELATED APIs

  //booking source list
  getBookingSourceList() {
    return axios
      .get(API_URL + "hotel-setting/booking-source", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  //create booking source
  createBookingSource(data) {
    return axios
      .post(API_URL + "hotel-setting/booking-source", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit booking source
  editBookingSource(data, booking_source_id) {
    return axios
      .patch(
        API_URL + "hotel-setting/booking-source/" + booking_source_id,
        data,
        {
          headers: authHeaderWithMultipartData(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  //booking rule delete
  deleteBookingSource(booking_source_id) {
    return axios.delete(
      API_URL + "hotel-setting/booking-source/" + booking_source_id,
      {
        headers: authHeader(),
      }
    );
  }
  //booking source details
  getBookingSourceDetails(booking_source_id) {
    return axios
      .get(API_URL + "hotel-setting/booking-source/" + booking_source_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //Booking source by name
  getBookingSourceByName() {
    return axios
      .get(API_URL + "hotel-setting/booking-source-name", {
        headers: authHeader(),
      })
      .then((response) => response.data);
  }

  // BOOKING PAYMENT RULE RELATED APIs

  //booking payment rule
  getBookingSourcePaymentRule(booking_source_id) {
    return axios
      .get(API_URL + "hotel-setting/payment-rule/" + booking_source_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //booking payment rule update
  updateBookingPaymentRule(data, booking_source_id) {
    return axios
      .patch(
        API_URL + "hotel-setting/payment-rule/" + booking_source_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // PAYMENT GATEWAY RELATED APIs

  // connect payment gateway
  connectPaymentGetway(data) {
    return axios
      .post(API_URL + "hotel-setting/payment-gateway-connect", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // get stripe payment gateway details
  getStripePaymentGatewayDetails() {
    return axios
      .get(API_URL + "hotel-setting/payment-gateway", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // get payment gateway list
  getPaymentGatewayList() {
    return axios
      .get(API_URL + "hotel-setting/payment-gateway", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // PMS RELATED RELATED APIs

  // Get connected PMS
  getConnectedPMS() {
    return axios
      .get(API_URL + "hotel-setting/pms-connection", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Add New PMS connection
  AddPMS(data) {
    return axios
      .post(API_URL + "hotel-setting/pms-connection/", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Sync PMS records
  syncPMSRecords() {
    return axios
      .get(API_URL + "hotel-setting/pms-synchroniz/booking", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Sync PMS Room records
  syncPMSRoomRecords() {
    return axios
      .get(API_URL + "hotel-setting/pms-synchroniz/room", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // pms-synchroniz-record
  getPMSSyncRecord(filter = "") {
    return axios
      .get(API_URL + "hotel-setting/pms-synchroniz-record" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  //TERMS AND CONDITIONS RELATED APIs

  // get terms list
  getTermsList(filter) {
    return axios
      .get(API_URL + "hotel-setting/terms-and-condition" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // create terms
  createTerms(data) {
    return axios
      .post(API_URL + "hotel-setting/terms-and-condition", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // edit terms
  editTerms(data, id) {
    return axios
      .patch(API_URL + "hotel-setting/terms-and-condition/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete term
  deleteTerms(id) {
    return axios.delete(API_URL + "hotel-setting/terms-and-condition/" + id, {
      headers: authHeader(),
    });
  }

  // GUEST EXPERIENCE RELATED APIs

  //get guest experience list
  getGuestExperienceList() {
    return axios
      .get(API_URL + "hotel-setting/guest-experience", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //edit guest experience
  editGuestExperience(data, guest_experience_id) {
    return axios
      .patch(
        API_URL + "hotel-setting/guest-experience/" + guest_experience_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }

  // CUSTOM QUESTIONS RELATED APIs

  //get custom question list
  getCustomQuestionList() {
    return axios
      .get(API_URL + "hotel-setting/custom-question", { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // create custom question
  createCustomQuestion(data) {
    return axios
      .post(API_URL + "hotel-setting/custom-question", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // update custom question
  updateCustomQuestion(data, question_id) {
    return axios
      .patch(API_URL + "hotel-setting/custom-question/" + question_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //delete custom question
  deleteCustomQuestion(question_id) {
    return axios
      .delete(API_URL + "hotel-setting/custom-question/" + question_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  getEmailNotificationSetting(email_notification_type) {
    return axios
      .get(
        API_URL + `hotel-setting/notification/email/${email_notification_type}`,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  updateEmailNotificationSetting(email_notification_setting_id, data) {
    return axios
      .patch(
        API_URL +
          "hotel-setting/notification/email/" +
          email_notification_setting_id,
        data,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  // TAXES RELATED APIs

  // tax-rule list
  getTaxList(filter = "") {
    return axios
      .get(API_URL + "hotel-setting/tax-rule" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // tax-rule details
  getTaxDetails(tax_id) {
    return axios
      .get(API_URL + "hotel-setting/tax-rule/" + tax_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // create tax-rule
  createTax(data) {
    return axios
      .post(API_URL + "hotel-setting/tax-rule", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // update tax-rule
  editTax(tax_id, data) {
    return axios
      .patch(API_URL + "hotel-setting/tax-rule/" + tax_id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // delete tax-rule
  deleteTax(tax_id) {
    return axios
      .delete(API_URL + "hotel-setting/tax-rule/" + tax_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // CHARGES TYPE RELATED APIs

  // Charges-type list
  getChargesTypeList(filter = "") {
    return axios
      .get(API_URL + "hotel-setting/charges-type" + filter, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  //charges-type details
  getChargesTypeDetails(charges_type_id) {
    return axios
      .get(API_URL + "hotel-setting/charges-type/" + charges_type_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Create charges-type
  createChargesType(data) {
    return axios
      .post(API_URL + "hotel-setting/charges-type", data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update charges-type
  editChargesType(charges_type_id, data) {
    return axios
      .patch(API_URL + "hotel-setting/charges-type/" + charges_type_id, data, {
        headers: authHeaderWithMultipartData(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete charges-type
  deleteChargesType(charges_type_id) {
    return axios
      .delete(API_URL + "hotel-setting/charges-type/" + charges_type_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }

  // UPSELL RELATED APIs

  // Get all up sell
  getAllUpSell(filter) {
    return axios
      .get(API_URL + "hotel-setting/upsell" + filter, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Create new up sell
  createUpSell(data) {
    return axios
      .post(API_URL + "hotel-setting/upsell", data, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Update up sell by id
  updateUpSell(id, data) {
    return axios
      .patch(API_URL + "hotel-setting/upsell/" + id, data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Delete up sell by id
  deleteUpSell(id) {
    return axios
      .delete(API_URL + "hotel-setting/upsell/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }
  // Get details of up sell item by id
  getUpSellDetails(id) {
    return axios
      .get(API_URL + "hotel-setting/upsell/" + id, { headers: authHeader() })
      .then((response) => {
        return response.data;
      });
  }

  // EMAIL TEMPLATE RELATED APIs

  getNotification() {
    return axios
      .get(API_URL + "app-setting/notification-group", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  getEmailNotification(notification_group_id, recipient) {
    return axios
      .get(
        API_URL +
          `app-setting/notification/email-type/${notification_group_id}?is_recipient=${recipient}`,
        { headers: authHeader() }
      )
      .then((response) => {
        return response.data;
      });
  }

  // NOTIFICATION AND ALERTS RELATED APIs

  // get unread notification list
  async getUnreadNotification() {
    const response = await axios.get(API_URL + "msg/notification-and-alerts", {
      headers: authHeader(),
    });
    return response.data;
  }
  // get  notification list
  async getNotificationList() {
    const response = await axios.get(
      API_URL + "msg/notification-and-alerts/list",
      {
        headers: authHeader(),
      }
    );
    return response.data;
  }

  // MENU RELATED APIs

  // Get Menu Header Images
  getPageHeaderImages() {
    return axios
      .get(API_URL + "hotel/directory-header-image", {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Add Menu Header Images
  addPageHeaderImages(data) {
    return axios
      .post(API_URL + "hotel/directory-header-image", data, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
  // Update Hotel Directory Menu page
  updatePageHeaderImage(header_image_id, data) {
    return axios
      .patch(
        API_URL + "hotel/directory-header-image/" + header_image_id,
        data,
        {
          headers: authHeader(),
        }
      )
      .then((response) => {
        return response.data;
      });
  }
  // Delete Hotel Directory Menu page
  deletePageHeaderImage(header_image_id) {
    return axios
      .delete(API_URL + "hotel/directory-header-image/" + header_image_id, {
        headers: authHeader(),
      })
      .then((response) => {
        return response.data;
      });
  }
}
export default new HotelService();
